import styled from 'styled-components'
import SelectOptions from 'src/components/Apply/Options'
import SelectMonths from 'src/components/Apply/Months'
import SelectDay from 'src/components/Apply/Day'
import MoreOptions from 'src/components/Apply/MoreOptions'
import Checkboxes from 'src/components/Apply/Checkboxes'
import SingleLineInput from 'src/components/form/SingleLineInput'
import OptionCard from 'src/components/Apply/OptionCard'
import Select from 'src/components/form/Select'
import CheckElement from 'src/components/form/Check'
import RangeSliderIncome from 'src/components/Apply/RangeSliderIncome'
import { ContainerExtraSmall, ApplyBContainerExtraSmall } from 'src/styles/Container'
import AutoYears from 'src/components/Apply/AutoYears'
import AutoMakes from 'src/components/Apply/AutoMakes'
import AutoModels from 'src/components/Apply/AutoModels'
import MedicareYear from 'src/components/Apply/MedicareYear'
import { SubHeading1 } from 'src/styles/Typography'
import grabColor from 'src/utils/grabColor'

import { short, long } from './insuranceCompanys'

const OptionCardsSmallContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(188px, 1fr));
  gap: 1rem;
`

const TitleContainer = styled.div`
  margin: 1rem 0 2.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    margin: 0 0 1rem;
  }
`

const OptionCardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin: 1rem 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: column;
  }
`

const OptionCardsContainerB = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 1rem 0 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    text-align: center;
    align-items: center;
    gap: 1rem;
  }

  @media (max-width: 500px) {
    button {
      max-width: 144px;
      width: 100%;
    }
  }
`

const TitleContainerB = styled.div`
  margin: 0.9rem 0 0.9rem;

  ${SubHeading1} {
    text-align: center;
    color: ${grabColor('detail')};
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-top: -0.4rem;
    margin-bottom: 0.6rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    margin: 0.2rem 0 0.2rem;
  }
`

const MultiOptionSelectContainer = styled.div`
  margin-bottom: 2rem;
`

const MultiOptionSelectContainerB = styled.div`
  margin-bottom: 1rem;

  label {
    font-size: 14px;
  }
`

const SingleOptionSelectContainer = styled.div`
  margin-bottom: 2rem;
`
const SingleSelectContainer = styled.div`
  margin-bottom: 2rem;
`

const OptinContainer = styled.div``
const OptinContainerB = styled.div`
  text-align: center;
  margin: 1rem auto;

  label {
    font-size: 14px;
    text-align: left;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 0 auto 0.5rem;

    label {
      line-height: 24px;
    }
  }
`
const MonthsContainer = styled.div``
const AutoYearContainer = styled.div``
const AutoYearContainerB = styled.div``
const HouseholdSizeContainer = styled.div``
const RangeSliderContainer = styled.div``
const SingleLineInputContainer = styled.div`
  margin-bottom: 2rem;
`

const SingleLineInputContainerB = styled.div`
  margin-bottom: 1rem;
  max-width: 320px;
  width: 100%;
  margin: 0 auto 1rem;
`

const SingleLineInputContainerBB = styled.div`
  margin-bottom: 1rem;
  max-width: 360px;
  width: 100%;
  margin: 0 auto 1rem;
`

const MultipleInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem 2rem;
  margin: 0 0 2rem;

  > * {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: column;
  }
`

const MultipleInputContainerBB = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 0 0 1rem;

  > * {
    width: 100%;
    max-width: 172px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    > * {
      width: 100%;
      max-width: initial;
    }
  }
`

const MultipleSelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem 4rem;
  margin: 0 0 2rem;

  > * {
    width: 100%;
    h3 {
      margin-bottom: -8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    gap: 1rem 2rem;
    /* flex-direction: column; */
  }
`

const MultipleSelectContainerB = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem 4rem;
  margin: 0 0 1rem;

  > * {
    width: 100%;
    h3 {
      margin-bottom: -8px;
    }

    label {
      font-size: 16px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    gap: 1rem 2rem;
    /* flex-direction: column; */
  }
`

const MultipleSelectContainerDOB = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem 4rem;
  margin: 0 0 2rem;

  > * {
    width: 100%;
    h3 {
      margin-bottom: -8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    gap: 1rem 2rem;
    flex-direction: column;
  }
`

const months = [
  { value: '1', name: 'January', days: 31 },
  { value: '2', name: 'February', days: 28 },
  { value: '3', name: 'March', days: 31 },
  { value: '4', name: 'April', days: 30 },
  { value: '5', name: 'May', days: 31 },
  { value: '6', name: 'June', days: 30 },
  { value: '7', name: 'July', days: 31 },
  { value: '8', name: 'August', days: 31 },
  { value: '9', name: 'September', days: 30 },
  { value: '10', name: 'October', days: 31 },
  { value: '11', name: 'November', days: 30 },
  { value: '12', name: 'December', days: 31 },
]

const defaultMonthTitle = 'What month were you born?'
const defaultDayTitle = 'What day were you born?'

export const mockSteps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    title: 'Tell us a bit about yourself',
    subTitle:
      'Select any items below that apply to help us find the plans that make sense for you.',
    TitleContainer: TitleContainer,
    actionMeta: 'Action Meta Test',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'options1',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Heading 1',
              summary: 'Summary',
              image: true,
              value: '1',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Heading 2',
              summary: 'Summary',
              value: '2',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Heading 3',
              summary: 'Summary',
              value: '3',
            },
          },
        ],
      },
      // {
      //   Container: OptionCardsContainer,
      //   name: 'options11',
      //   children: [
      //     {
      //       component: OptionCard,
      //       props: {
      //         heading: 'Heading 1',
      //         summary: 'Summary',
      //         value: '1',
      //       },
      //     },
      //     {
      //       component: OptionCard,
      //       props: {
      //         heading: 'Heading 2',
      //         summary: 'Summary',
      //         value: '2',
      //       },
      //     },
      //     {
      //       component: OptionCard,
      //       props: {
      //         heading: 'Heading 3',
      //         summary: 'Summary',
      //         value: '3',
      //       },
      //     },
      //   ],
      // },
    ],
  },
  {
    step: '2',
    title: 'Hi I am step 2',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    continue: true,
    form: [
      {
        Container: OptionCardsSmallContainer,
        name: 'options2',
        children: [
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '1',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '2',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '3',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '4',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '5',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '6',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '7',
            },
          },
          {
            component: OptionCard,
            props: {
              summary: 'Summary',
              value: '8',
            },
          },
        ],
      },
    ],
  },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'step 3',
    subTitle: 'Test single option select',
    form: [
      {
        Container: SingleOptionSelectContainer,
        name: 'options3',
        component: SelectOptions,
        props: {
          options: [
            { placeholder: 'Option One', value: '1' },
            { placeholder: 'Option Two', value: '2' },
          ],
          label: 'Single Option Select Label',
          note: 'Note',
        },
      },
      {
        Container: SingleOptionSelectContainer,
        name: 'options33',
        component: SelectOptions,
        props: {
          options: [
            { placeholder: 'Option One', value: '1' },
            { placeholder: 'Option Two', value: '2' },
          ],
          label: 'Single Option Label',
        },
      },
      {
        Container: SingleOptionSelectContainer,
        name: 'options333',
        component: SelectOptions,
        props: {
          options: [
            { placeholder: 'Male', value: '11' },
            { placeholder: 'Female', value: '22' },
          ],
          label: 'test',
        },
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    continue: true,
    TitleContainer: TitleContainer,
    title: 'Test some inputs',
    subTitle: 'Test some inputs',
    actionMeta: 'Action Meta Test step 4',
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'first_name',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          id: 'first_name',
          name: 'first_name',
          label: 'First Name',
          note: 'Note',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'options44',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          id: 'options44',
          name: 'options44',
          label: 'Single Line Input Label',
        },
      },
      {
        Container: SingleOptionSelectContainer,
        name: 'gender',
        component: SelectOptions,
        props: {
          options: [
            { placeholder: 'Male', value: 'male' },
            { placeholder: 'Female', value: 'female' },
          ],
          label: 'Gender',
        },
      },
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'options44441',
              name: 'options44441',
              label: 'Multi Line Input Label',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'options44442',
              name: 'options44442',
              label: 'Multi Line Input Label',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'options44443',
              name: 'options44443',
              label: 'Multi Line Input Label',
            },
          },
        ],
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'step 5',
    subTitle: 'Test Multi Option Select',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'address',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          id: 'address',
          name: 'address',
          label: 'Address',
          note: 'Note',
        },
      },
      {
        Container: MultiOptionSelectContainer,
        name: 'options5',
        component: Checkboxes,
        componentType: 'checkboxes',
        props: {
          options: [
            { label: 'Option One', name: 'options5', value: '1' },
            { label: 'Option Two', name: 'options5', value: '2' },
            { label: 'Option Three', name: 'options5', value: '3' },
            { label: 'Option Four', name: 'options5', value: '4' },
            { label: 'Option Five', name: 'options5', value: '5' },
            { label: 'Option Six', name: 'options5', value: '6' },
            { label: 'Option Seven', name: 'options5', value: '7' },
          ],
          label: 'Multi Option Select Label',
          note: 'Note',
        },
      },
    ],
  },
]

export const medicareD1Steps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    title: 'Are you currently enrolled in Medicare parts A & B?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'currently_insured',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '2',
    stepName: 'dob',
    Container: ContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '3',
    Container: ContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'What is your birth year?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'year',
        component: MedicareYear,
        componentType: 'input',
        props: {
          id: 'year',
          name: 'year',
          label: '',
          // autoComplete: 'bday-year',
        },
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'How may we contact you?',
    continue: true,
    stepRole: 'zip_code',
    form: [
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainer,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
      {
        Container: OptinContainer,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Final Expense',
          name: 'optin',
        },
      },
    ],
  },
]

export const medicareD4BSteps = [
  {
    step: '1',
    Container: ApplyBContainerExtraSmall,
    title: 'Are you currently enrolled in Medicare parts A & B?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'currently_insured',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '2',
    stepName: 'dob',
    Container: ApplyBContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainerB,
    subTitle: '*Not Required',
    allowSkip: true,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          design: 'b',
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '3',
    Container: ApplyBContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainerB,
    subTitle: '*Not Required',
    allowSkip: true,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          design: 'b',
          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '4',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'What is your birth year?',
    subTitle: '*Not Required',
    allowSkip: true,
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'year',
        component: MedicareYear,
        componentType: 'input',
        props: {
          design: 'b',
          height: '42px',
          width: '52px',
          padding: '0.8rem',
          id: 'year',
          name: 'year',
          label: '',
          // autoComplete: 'bday-year',
        },
      },
    ],
  },
  {
    step: '5',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'What is your gender*',
    subTitle: '*Not Required',
    allowSkip: true,
    // actionMeta: 'This is not required.',
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '6',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Please enter your street address',
    continue: true,
    stepRole: 'zip_code',
    subTitle: '*Street Address Not Required',
    allowSkip: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainerB,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
    ],
  },
  {
    step: '7',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainerBB,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainerB,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Final Expense',
          name: 'optin',
        },
      },
    ],
  },
]

export const lifeASteps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    title: 'How much coverage are you looking for?',
    TitleContainer: TitleContainer,
    continue: true,
    form: [
      {
        Container: SingleSelectContainer,
        component: Select,
        componentType: 'select',
        name: 'coverage',
        // defaultValue: '5000',
        props: {
          mobileFriendlySelect: true,
          ariaLabel: 'coverage',
          size: 'large',
          options: [
            { name: 'coverage', id: '5000', value: '$5,000' },
            { name: 'coverage', id: '10000', value: '$10,000' },
            { name: 'coverage', id: '20000', value: '$20,000' },
            { name: 'coverage', id: '50000', value: '$50,000' },
            { name: 'coverage', id: '100000', value: '$100,000' },
            { name: 'coverage', id: '200000', value: '$200,000' },
            { name: 'coverage', id: '300000', value: '$300,000' },
            { name: 'coverage', id: '400000', value: '$400,000' },
            { name: 'coverage', id: '500000', value: '$500,000' },
            { name: 'coverage', id: '750000', value: '$750,000' },
            { name: 'coverage', id: '1000000', value: '$1,000,000' },
          ],
        },
      },
    ],
  },
  // {
  //   step: '2',
  //   Container: ContainerExtraSmall,
  //   title: defaultMonthTitle,
  //   TitleContainer: TitleContainer,
  //   form: [
  //     {
  //       Container: MonthsContainer,
  //       name: 'month',
  //       component: SelectMonths,
  //       props: {
  //         options: months.map((month) => ({
  //           placeholder: month.name,
  //           value: month.value,
  //         })),
  //       },
  //     },
  //   ],
  // },
  // {
  //   step: '3',
  //   Container: ContainerExtraSmall,
  //   title: defaultDayTitle,
  //   TitleContainer: TitleContainer,
  //   form: [
  //     {
  //       Container: MonthsContainer,
  //       name: 'day',
  //       component: SelectDay,
  //       props: {
  //         options: Array.from({ length: 31 }, (_, i) => ({
  //           placeholder: `${i + 1}`,
  //           value: `${i + 1}`,
  //         })),
  //       },
  //     },
  //   ],
  // },
  // {
  //   step: '4',
  //   Container: ContainerExtraSmall,
  //   TitleContainer: TitleContainer,
  //   title: 'What is your birth year?',
  //   continue: true,
  //   form: [
  //     {
  //       Container: SingleLineInputContainer,
  //       name: 'year',
  //       component: SingleLineInput,
  //       componentType: 'input',
  //       props: {
  //         id: 'year',
  //         name: 'year',
  //         label: '',
  //         autoComplete: 'bday-year',
  //       },
  //     },
  //   ],
  // },
  {
    step: '2',
    stepName: 'dob',
    Container: ContainerExtraSmall,
    title: 'What is your date of birth?',
    TitleContainer: TitleContainer,
    continue: true,
    form: [
      {
        Container: MultipleSelectContainerDOB,
        componentType: 'multi-select',
        children: [
          {
            name: 'month',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'month',
              size: 'large',
              label: 'Month',
              placeholder: 'Month',
              options: months.map((month) => ({
                name: 'month',
                value: month.name,
                id: month.value,
              })),
            },
          },
          {
            name: 'day',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'day',
              size: 'large',
              label: 'Day',
              placeholder: 'Day',
              options: Array.from({ length: 31 }, (_, i) => ({
                name: 'day',
                value: `${i + 1}`,
                id: `${i + 1}`,
              })),
            },
          },
          {
            name: 'year',
            componentType: 'select',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'year',
              size: 'large',
              label: 'Year',
              placeholder: 'Year',
              defaultValue: '1970',
              options: Array.from({ length: 100 }, (_, i) => ({
                name: 'year',
                value: `${i + 1920}`,
                id: `${i + 1920}`,
              })),
            },
          },
        ],
      },
    ],
  },
  // {
  //   step: '2',
  //   stepName: 'dob',
  //   stepRole: 'dob-single-step',
  //   Container: ContainerExtraSmall,
  //   TitleContainer: TitleContainer,
  //   title: 'What is your birthday?',
  //   continue: true,
  //   form: [
  //     {
  //       Container: MultipleSelectContainer,
  //       componentType: 'multi-input',
  //       name: 'dob',
  //       children: [
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'month',
  //             name: 'month',
  //             label: 'Month',
  //             placeholder: 'MM',
  //             // autoComplete: 'bday-month',
  //             skipOnMax: true,
  //             maxLength: 2,
  //           },
  //         },
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'day',
  //             name: 'day',
  //             label: 'Day',
  //             placeholder: 'DD',
  //             // autoComplete: 'bday-day',
  //             skipOnMax: true,
  //             maxLength: 2,
  //           },
  //         },
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'year',
  //             name: 'year',
  //             placeholder: 'YYYY',
  //             label: 'Year',
  //             // autoComplete: 'bday-year',
  //             maxLength: 4,
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please select your gender.',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    title: 'How tall are you?',
    TitleContainer: TitleContainer,
    continue: true,
    form: [
      {
        Container: MultipleSelectContainer,
        componentType: 'multi-select',
        children: [
          {
            component: Select,
            name: 'height_ft',
            props: {
              mobileFriendlySelect: true,
              label: 'Feet',
              placeholder: 'ft.',
              name: 'height_ft',
              size: 'large',
              options: [
                { name: 'height_ft', id: '3', value: "3'" },
                { name: 'height_ft', id: '4', value: "4'" },
                { name: 'height_ft', id: '5', value: "5'" },
                { name: 'height_ft', id: '6', value: "6'" },
                { name: 'height_ft', id: '7', value: "7'" },
              ],
            },
          },
          {
            component: Select,
            name: 'height_in',
            props: {
              mobileFriendlySelect: true,
              label: 'Inches',
              placeholder: 'in.',
              name: 'height_in',
              size: 'large',
              options: [
                { name: 'height_in', id: '0', value: '0"' },
                { name: 'height_in', id: '1', value: '1"' },
                { name: 'height_in', id: '2', value: '2"' },
                { name: 'height_in', id: '3', value: '3"' },
                { name: 'height_in', id: '4', value: '4"' },
                { name: 'height_in', id: '5', value: '5"' },
                { name: 'height_in', id: '6', value: '6"' },
                { name: 'height_in', id: '7', value: '7"' },
                { name: 'height_in', id: '8', value: '8"' },
                { name: 'height_in', id: '9', value: '9"' },
                { name: 'height_in', id: '10', value: '10"' },
                { name: 'height_in', id: '11', value: '11"' },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'What is your weight?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'weight',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          type: 'number',
          id: 'weight',
          name: 'weight',
          label: '',
        },
      },
    ],
  },
  {
    step: '6',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Have you been treated or diagnosed for any of these medical conditions?*',
    actionMeta: '*Choose all that apply.',
    continue: true,
    form: [
      {
        Container: MultiOptionSelectContainer,
        name: 'conditions',
        component: Checkboxes,
        componentType: 'checkboxes',
        props: {
          options: [
            { value: 'alcohol', name: 'conditions', label: 'Alcohol or Substance Abuse' },
            {
              value: 'alzheimers',
              name: 'conditions',
              label: "Alzheimer's disease or Dementia",
            },
            {
              value: 'oxygen',
              name: 'conditions',
              label: 'Any condition requiring use of oxygen',
            },
            { value: 'chf', name: 'conditions', label: 'Congestive Heart Failure(CHF)' },
            { value: 'heart', name: 'conditions', label: 'Heart Attack or Stroke' },
            { value: 'hiv', name: 'conditions', label: 'HIV or AIDS' },
            {
              value: 'melanoma',
              name: 'conditions',
              label: 'Internal cancer, melanoma or leukemia',
            },
            {
              value: 'kidney',
              name: 'conditions',
              label: 'Kidney disease requiring dialysis',
            },
            { value: 'als', name: 'conditions', label: "Lou Gehrig's Disease(ALS)" },
            {
              value: 'parkisons',
              name: 'conditions',
              label: "Neuromuscular(Parkinson's, CP, MS)",
            },
          ],
        },
      },
    ],
  },
  {
    step: '7',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Do you use tobacco?',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'use_tobacco',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '8',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please enter your street address',
    stepRole: 'zip_code',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
    ],
  },
  {
    step: '9',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainer,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainer,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Health Insurance',
          name: 'optin',
        },
      },
    ],
  },
]

export const lifeBSteps = [
  {
    step: '1',
    Container: ApplyBContainerExtraSmall,
    title: 'How much coverage are you looking for?',
    TitleContainer: TitleContainerB,
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        component: Select,
        componentType: 'select',
        name: 'coverage',
        // defaultValue: '5000',
        props: {
          mobileFriendlySelect: true,
          ariaLabel: 'coverage',
          size: 'medium',
          options: [
            { name: 'coverage', id: '5000', value: '$5,000' },
            { name: 'coverage', id: '10000', value: '$10,000' },
            { name: 'coverage', id: '20000', value: '$20,000' },
            { name: 'coverage', id: '50000', value: '$50,000' },
            { name: 'coverage', id: '100000', value: '$100,000' },
            { name: 'coverage', id: '200000', value: '$200,000' },
            { name: 'coverage', id: '300000', value: '$300,000' },
            { name: 'coverage', id: '400000', value: '$400,000' },
            { name: 'coverage', id: '500000', value: '$500,000' },
            { name: 'coverage', id: '750000', value: '$750,000' },
            { name: 'coverage', id: '1000000', value: '$1,000,000' },
          ],
        },
      },
    ],
  },
  {
    step: '2',
    stepName: 'dob',
    Container: ApplyBContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          design: 'b',
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '3',
    Container: ApplyBContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          design: 'b',
          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '4',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'What is your birth year?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'year',
        component: MedicareYear,
        componentType: 'input',
        props: {
          design: 'b',
          height: '42px',
          width: '52px',
          padding: '0.8rem',
          id: 'year',
          name: 'year',
          label: '',
          // autoComplete: 'bday-year',
        },
      },
    ],
  },
  {
    step: '5',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'What is your gender*',
    subTitle: '*Not Required',
    allowSkip: true,
    // actionMeta: 'This is not required.',
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  // {
  //   step: '6',
  //   Container: ApplyBContainerExtraSmall,
  //   title: 'How tall are you?',
  //   TitleContainer: TitleContainerB,
  //   continue: true,
  //   form: [
  //     {
  //       Container: MultipleSelectContainerB,
  //       componentType: 'multi-select',
  //       children: [
  //         {
  //           component: Select,
  //           name: 'height_ft',
  //           props: {
  //             mobileFriendlySelect: true,
  //             label: 'Feet',
  //             placeholder: 'ft.',
  //             name: 'height_ft',
  //             size: 'medium',
  //             options: [
  //               { name: 'height_ft', id: '3', value: "3'" },
  //               { name: 'height_ft', id: '4', value: "4'" },
  //               { name: 'height_ft', id: '5', value: "5'" },
  //               { name: 'height_ft', id: '6', value: "6'" },
  //               { name: 'height_ft', id: '7', value: "7'" },
  //             ],
  //           },
  //         },
  //         {
  //           component: Select,
  //           name: 'height_in',
  //           props: {
  //             mobileFriendlySelect: true,
  //             label: 'Inches',
  //             placeholder: 'in.',
  //             name: 'height_in',
  //             size: 'medium',
  //             options: [
  //               { name: 'height_in', id: '0', value: '0"' },
  //               { name: 'height_in', id: '1', value: '1"' },
  //               { name: 'height_in', id: '2', value: '2"' },
  //               { name: 'height_in', id: '3', value: '3"' },
  //               { name: 'height_in', id: '4', value: '4"' },
  //               { name: 'height_in', id: '5', value: '5"' },
  //               { name: 'height_in', id: '6', value: '6"' },
  //               { name: 'height_in', id: '7', value: '7"' },
  //               { name: 'height_in', id: '8', value: '8"' },
  //               { name: 'height_in', id: '9', value: '9"' },
  //               { name: 'height_in', id: '10', value: '10"' },
  //               { name: 'height_in', id: '11', value: '11"' },
  //             ],
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   step: '7',
  //   Container: ApplyBContainerExtraSmall,
  //   TitleContainer: TitleContainerB,
  //   title: 'What is your weight?',
  //   continue: true,
  //   form: [
  //     {
  //       Container: SingleLineInputContainerB,
  //       name: 'weight',
  //       component: SingleLineInput,
  //       componentType: 'input',
  //       props: {
  //         type: 'number',
  //         id: 'weight',
  //         name: 'weight',
  //         label: '',
  //         design: 'b',
  //         height: '40px',
  //       },
  //     },
  //   ],
  // },
  {
    step: '6',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Have you been treated or diagnosed for any of these medical conditions?*',
    subTitle: '*Choose all that apply.',
    continue: true,
    form: [
      {
        Container: MultiOptionSelectContainerB,
        name: 'conditions',
        component: Checkboxes,
        componentType: 'checkboxes',
        props: {
          options: [
            { value: 'alcohol', name: 'conditions', label: 'Alcohol or Substance Abuse' },
            {
              value: 'alzheimers',
              name: 'conditions',
              label: "Alzheimer's disease or Dementia",
            },
            {
              value: 'oxygen',
              name: 'conditions',
              label: 'Any condition requiring use of oxygen',
            },
            { value: 'chf', name: 'conditions', label: 'Congestive Heart Failure(CHF)' },
            { value: 'heart', name: 'conditions', label: 'Heart Attack or Stroke' },
            { value: 'hiv', name: 'conditions', label: 'HIV or AIDS' },
            {
              value: 'melanoma',
              name: 'conditions',
              label: 'Internal cancer, melanoma or leukemia',
            },
            {
              value: 'kidney',
              name: 'conditions',
              label: 'Kidney disease requiring dialysis',
            },
            { value: 'als', name: 'conditions', label: "Lou Gehrig's Disease(ALS)" },
            {
              value: 'parkisons',
              name: 'conditions',
              label: "Neuromuscular(Parkinson's, CP, MS)",
            },
          ],
        },
      },
    ],
  },
  // {
  //   step: '9',
  //   Container: ApplyBContainerExtraSmall,
  //   TitleContainer: TitleContainerB,
  //   title: 'Do you use tobacco?',
  //   form: [
  //     {
  //       Container: OptionCardsContainerB,
  //       name: 'use_tobacco',
  //       children: [
  //         {
  //           component: OptionCard,
  //           props: {
  //             design: 'b',
  //             maxWidth: '160px',
  //             heading: 'Yes',
  //             value: 'Yes',
  //           },
  //         },
  //         {
  //           component: OptionCard,
  //           props: {
  //             design: 'b',
  //             maxWidth: '160px',
  //             heading: 'No',
  //             value: 'No',
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    step: '7',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Please enter your street address',
    stepRole: 'zip_code',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainerB,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
    ],
  },
  {
    step: '8',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainerBB,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainerB,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Medicare Insurance',
          name: 'optin',
        },
      },
    ],
  },
]

export const medicareD4Steps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    title: 'Are you currently enrolled in Medicare parts A & B?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'currently_insured',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '2',
    stepName: 'dob',
    Container: ContainerExtraSmall,
    title: 'What is your date of birth?',
    TitleContainer: TitleContainer,
    actionMeta: 'This is not required.',
    allowSkip: true,
    continue: true,
    form: [
      {
        Container: MultipleSelectContainerDOB,
        componentType: 'multi-select',
        children: [
          {
            name: 'month',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'month',
              size: 'large',
              label: 'Month',
              placeholder: 'Month',
              options: months.map((month) => ({
                name: 'month',
                value: month.name,
                id: month.value,
              })),
            },
          },
          {
            name: 'day',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'day',
              size: 'large',
              label: 'Day',
              placeholder: 'Day',
              options: Array.from({ length: 31 }, (_, i) => ({
                name: 'day',
                value: `${i + 1}`,
                id: `${i + 1}`,
              })),
            },
          },
          {
            name: 'year',
            componentType: 'select',
            component: Select,
            props: {
              mobileFriendlySelect: true,
              name: 'year',
              size: 'large',
              label: 'Year',
              placeholder: 'Year',
              defaultValue: '1953',
              options: Array.from({ length: 100 }, (_, i) => ({
                name: 'year',
                value: `${i + 1920}`,
                id: `${i + 1920}`,
              })),
            },
          },
        ],
      },
    ],
  },
  // {
  //   step: '2',
  //   stepName: 'dob',
  //   stepRole: 'dob-single-step',
  //   Container: ContainerExtraSmall,
  //   TitleContainer: TitleContainer,
  //   title: 'What is your birthday?',
  //   continue: true,
  //   form: [
  //     {
  //       Container: MultipleSelectContainer,
  //       componentType: 'multi-input',
  //       name: 'dob',
  //       children: [
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'month',
  //             name: 'month',
  //             label: 'Month',
  //             placeholder: 'MM',
  //             // autoComplete: 'bday-month',
  //             skipOnMax: true,
  //             maxLength: 2,
  //           },
  //         },
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'day',
  //             name: 'day',
  //             label: 'Day',
  //             placeholder: 'DD',
  //             // autoComplete: 'bday-day',
  //             skipOnMax: true,
  //             maxLength: 2,
  //           },
  //         },
  //         {
  //           Container: SingleLineInputContainer,
  //           component: SingleLineInput,
  //           componentType: 'input',
  //           props: {
  //             id: 'year',
  //             name: 'year',
  //             placeholder: 'YYYY',
  //             label: 'Year',
  //             // autoComplete: 'bday-year',
  //             maxLength: 4,
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please select your gender.*',
    allowSkip: true,
    actionMeta: 'This is not required.',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please enter your street address',
    continue: true,
    stepRole: 'zip_code',
    actionMeta: 'Street Address is not required.',
    allowSkip: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        required: false,
        props: {
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainer,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainer,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Final Expense',
          name: 'optin',
        },
      },
    ],
  },
]

export const healthASteps = [
  {
    step: '1',
    stepName: 'dob',
    Container: ContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '2',
    Container: ContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'What is your birth year?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'year',
        // component: SingleLineInput,
        component: MedicareYear,
        componentType: 'input',
        props: {
          id: 'year',
          name: 'year',
          label: '',
          // autoComplete: 'bday-year',
        },
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please select your gender.',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    title: 'What is your estimated household income?',
    TitleContainer: TitleContainer,
    continue: true,
    actionMeta: 'Income level does not affect your rate.',
    form: [
      {
        Container: RangeSliderContainer,
        name: 'estimated_household_income',
        component: RangeSliderIncome,
        componentType: 'range-slider',
        props: {
          step: 4000,
          min: 21000,
          max: 69000,
        },
      },
    ],
  },
  {
    step: '6',
    Container: ContainerExtraSmall,
    title: 'How many people reside in your household?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: HouseholdSizeContainer,
        name: 'household_size',
        component: SelectMonths,
        props: {
          options: Array.from({ length: 8 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '7',
    Container: ContainerExtraSmall,
    title: 'How tall are you?',
    TitleContainer: TitleContainer,
    continue: true,
    form: [
      {
        Container: MultipleSelectContainer,
        componentType: 'multi-select',
        children: [
          {
            component: Select,
            name: 'height_ft',
            props: {
              mobileFriendlySelect: true,
              label: 'Feet',
              placeholder: 'ft.',
              name: 'height_ft',
              size: 'large',
              options: [
                { name: 'height_ft', id: '3', value: "3'" },
                { name: 'height_ft', id: '4', value: "4'" },
                { name: 'height_ft', id: '5', value: "5'" },
                { name: 'height_ft', id: '6', value: "6'" },
                { name: 'height_ft', id: '7', value: "7'" },
              ],
            },
          },
          {
            component: Select,
            name: 'height_in',
            props: {
              mobileFriendlySelect: true,
              label: 'Inches',
              placeholder: 'in.',
              name: 'height_in',
              size: 'large',
              options: [
                { name: 'height_in', id: '0', value: '0"' },
                { name: 'height_in', id: '1', value: '1"' },
                { name: 'height_in', id: '2', value: '2"' },
                { name: 'height_in', id: '3', value: '3"' },
                { name: 'height_in', id: '4', value: '4"' },
                { name: 'height_in', id: '5', value: '5"' },
                { name: 'height_in', id: '6', value: '6"' },
                { name: 'height_in', id: '7', value: '7"' },
                { name: 'height_in', id: '8', value: '8"' },
                { name: 'height_in', id: '9', value: '9"' },
                { name: 'height_in', id: '10', value: '10"' },
                { name: 'height_in', id: '11', value: '11"' },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    step: '8',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'What is your weight?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'weight',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          type: 'number',
          id: 'weight',
          name: 'weight',
          label: '',
        },
      },
    ],
  },
  {
    step: '9',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Do you use tobacco?',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'use_tobacco',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '10',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please enter your street address',
    continue: true,
    stepRole: 'zip_code',
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
    ],
  },
  {
    step: '11',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainer,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainer,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Life Insurance',
          name: 'optin',
        },
      },
    ],
  },
]

export const autoASteps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Select your vehicle year',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoYears,
        name: 'veh_year',
        passData: true,
      },
    ],
  },
  {
    step: '2',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Select your vehicle make',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoMakes,
        name: 'veh_make',
        passData: true,
      },
    ],
  },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Select your vehicle model',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoModels,
        name: 'veh_model',
        passData: true,
      },
    ],
  },
  {
    step: '4',
    Container: ContainerExtraSmall,
    title: 'Do you have multiple vehicles?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'additional_vehicles',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '5',
    Container: ContainerExtraSmall,
    title: 'Add second driver?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'additional_drivers',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '6',
    Container: ContainerExtraSmall,
    title: 'Do you have a valid drivers license?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'drivers_license',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '7',
    Container: ContainerExtraSmall,
    title: 'Are you currently insured?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'currently_insured',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '8',
    Container: ContainerExtraSmall,
    title: 'Current auto insurance',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'insurance_company',
        component: MoreOptions,
        props: {
          options: short.map((item) => ({ value: item, placeholder: item })),
          moreOptions: long.map((item) => ({ value: item, placeholder: item })),
        },
      },
    ],
  },
  {
    step: '9',
    Container: ContainerExtraSmall,
    title: 'Married?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'married',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '10',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please select your gender.',
    form: [
      {
        Container: OptionCardsContainer,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '11',
    Container: ContainerExtraSmall,
    title: 'What is your credit score?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'credit_rating',
        component: SelectDay,
        props: {
          options: [
            { value: 'Poor', placeholder: 'Poor (below 580)' },
            { value: 'Average', placeholder: 'Average (580-679)' },
            { value: 'Good', placeholder: 'Good (680-719)' },
            { value: 'Excellent', placeholder: 'Excellent (720+)' },
          ],
        },
      },
    ],
  },
  {
    step: '12',
    Container: ContainerExtraSmall,
    title: 'Homeowner?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'homeowner',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Own',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'Rent',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '13',
    Container: ContainerExtraSmall,
    title: 'Are you a good driver?',
    subTitle: '(incident free in the last 3 years)',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'tickets_accidents_claims_past_3_years',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '14',
    Container: ContainerExtraSmall,
    title: 'How many tickets or accidents in the past 3 years?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'violations',
        component: SelectDay,
        props: {
          options: [
            { value: '0', placeholder: '0' },
            { value: '1', placeholder: '1' },
            { value: '2', placeholder: '2' },
            { value: '3', placeholder: '3' },
            { value: '4', placeholder: '4' },
            { value: '5', placeholder: '5+' },
          ],
        },
      },
    ],
  },
  {
    step: '15',
    Container: ContainerExtraSmall,
    title: 'Any DUI charges?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'dui_dwi',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '16',
    Container: ContainerExtraSmall,
    title: 'Do you need an SR-22?',
    TitleContainer: TitleContainer,
    form: [
      {
        Container: OptionCardsContainer,
        name: 'filing_required',
        children: [
          {
            component: OptionCard,
            props: {
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              heading: "No (or don't know)",
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '17',
    stepName: 'dob',
    Container: ContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '18',
    Container: ContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '19',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'What is your birth year?',
    continue: true,
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'year',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          id: 'year',
          name: 'year',
          label: '',
          autoComplete: 'bday-year',
        },
      },
    ],
  },
  {
    step: '20',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'Please enter your street address',
    continue: true,
    stepRole: 'zip_code',
    form: [
      {
        Container: SingleLineInputContainer,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
      {
        Container: SingleSelectContainer,
        component: Select,
        componentType: 'select',
        name: 'state',
        // defaultValue: '5000',
        props: {
          mobileFriendlySelect: true,
          ariaLabel: 'state',
          label: 'State',
          size: 'large',
          options: [
            { value: 'AZ', label: 'Arizona' },
            { value: 'AL', label: 'Alabama' },
            { value: 'AK', label: 'Alaska' },
            { value: 'AR', label: 'Arkansas' },
            { value: 'CA', label: 'California' },
            { value: 'CO', label: 'Colorado' },
            { value: 'CT', label: 'Connecticut' },
            { value: 'DC', label: 'District of Columbia' },
            { value: 'DE', label: 'Delaware' },
            { value: 'FL', label: 'Florida' },
            { value: 'GA', label: 'Georgia' },
            { value: 'HI', label: 'Hawaii' },
            { value: 'ID', label: 'Idaho' },
            { value: 'IL', label: 'Illinois' },
            { value: 'IN', label: 'Indiana' },
            { value: 'IA', label: 'Iowa' },
            { value: 'KS', label: 'Kansas' },
            { value: 'KY', label: 'Kentucky' },
            { value: 'LA', label: 'Louisiana' },
            { value: 'ME', label: 'Maine' },
            { value: 'MD', label: 'Maryland' },
            { value: 'MA', label: 'Massachusetts' },
            { value: 'MI', label: 'Michigan' },
            { value: 'MN', label: 'Minnesota' },
            { value: 'MS', label: 'Mississippi' },
            { value: 'MO', label: 'Missouri' },
            { value: 'MT', label: 'Montana' },
            { value: 'NE', label: 'Nebraska' },
            { value: 'NV', label: 'Nevada' },
            { value: 'NH', label: 'New Hampshire' },
            { value: 'NJ', label: 'New Jersey' },
            { value: 'NM', label: 'New Mexico' },
            { value: 'NY', label: 'New York' },
            { value: 'NC', label: 'North Carolina' },
            { value: 'ND', label: 'North Dakota' },
            { value: 'OH', label: 'Ohio' },
            { value: 'OK', label: 'Oklahoma' },
            { value: 'OR', label: 'Oregon' },
            { value: 'PA', label: 'Pennsylvania' },
            { value: 'RI', label: 'Rhode Island' },
            { value: 'SC', label: 'South Carolina' },
            { value: 'SD', label: 'South Dakota' },
            { value: 'TN', label: 'Tennessee' },
            { value: 'TX', label: 'Texas' },
            { value: 'UT', label: 'Utah' },
            { value: 'VT', label: 'Vermont' },
            { value: 'VA', label: 'Virginia' },
            { value: 'WA', label: 'Washington' },
            { value: 'WV', label: 'West Virginia' },
            { value: 'WI', label: 'Wisconsin' },
            { value: 'WY', label: 'Wyoming' },
          ].map(({ value, label }) => ({
            id: value,
            value: label,
            name: 'state',
          })),
        },
      },
    ],
  },
  {
    step: '21',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainer,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainer,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainer,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainer,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainer,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Life Insurance',
          name: 'optin',
        },
      },
    ],
  },
]

export const autoBSteps = [
  {
    step: '1',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Select your vehicle year',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoYears,
        name: 'veh_year',
        passData: true,
        props: { design: 'b' },
      },
    ],
  },
  {
    step: '2',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Select your vehicle make',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoMakes,
        name: 'veh_make',
        passData: true,
        props: { design: 'b' },
      },
    ],
  },
  {
    step: '3',
    Container: ContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Select your vehicle model',
    form: [
      {
        Container: AutoYearContainer,
        component: AutoModels,
        name: 'veh_model',
        passData: true,
        props: { design: 'b' },
      },
    ],
  },
  {
    step: '4',
    Container: ApplyBContainerExtraSmall,
    title: 'Do you have multiple vehicles?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'additional_vehicles',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '5',
    Container: ApplyBContainerExtraSmall,
    title: 'Add second driver?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'additional_drivers',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '6',
    Container: ApplyBContainerExtraSmall,
    title: 'Do you have a valid drivers license?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'drivers_license',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '7',
    Container: ApplyBContainerExtraSmall,
    title: 'Are you currently insured?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'currently_insured',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '8',
    Container: ContainerExtraSmall,
    title: 'Current auto insurance',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'insurance_company',
        component: MoreOptions,
        props: {
          options: short.map((item) => ({ value: item, placeholder: item })),
          moreOptions: long.map((item) => ({ value: item, placeholder: item })),
        },
      },
    ],
  },
  {
    step: '9',
    Container: ApplyBContainerExtraSmall,
    title: 'Married?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'married',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '10',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Please select your gender.',
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'gender',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Male',
              value: 'Male',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Female',
              value: 'Female',
            },
          },
        ],
      },
    ],
  },
  {
    step: '11',
    Container: ContainerExtraSmall,
    title: 'What is your credit score?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'credit_rating',
        component: SelectDay,
        props: {
          options: [
            { value: 'Poor', placeholder: 'Poor (below 580)' },
            { value: 'Average', placeholder: 'Average (580-679)' },
            { value: 'Good', placeholder: 'Good (680-719)' },
            { value: 'Excellent', placeholder: 'Excellent (720+)' },
          ],
        },
      },
    ],
  },
  {
    step: '12',
    Container: ApplyBContainerExtraSmall,
    title: 'Homeowner?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'homeowner',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Own',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Rent',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '13',
    Container: ApplyBContainerExtraSmall,
    title: 'Are you a good driver?',
    subTitle: '(incident free in the last 3 years)',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'tickets_accidents_claims_past_3_years',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '14',
    Container: ApplyBContainerExtraSmall,
    title: 'How many tickets or accidents in the past 3 years?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'violations',
        component: SelectDay,
        props: {
          options: [
            { value: '0', placeholder: '0' },
            { value: '1', placeholder: '1' },
            { value: '2', placeholder: '2' },
            { value: '3', placeholder: '3' },
            { value: '4', placeholder: '4' },
            { value: '5', placeholder: '5+' },
          ],
        },
      },
    ],
  },
  {
    step: '15',
    Container: ApplyBContainerExtraSmall,
    title: 'Any DUI charges?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'dui_dwi',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'No',
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '16',
    Container: ApplyBContainerExtraSmall,
    title: 'Do you need an SR-22?',
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: OptionCardsContainerB,
        name: 'filing_required',
        children: [
          {
            component: OptionCard,
            props: {
              design: 'b',
              maxWidth: '160px',
              heading: 'Yes',
              value: 'Yes',
            },
          },
          {
            component: OptionCard,
            props: {
              design: 'b',
              heading: "No (don't know)",
              value: 'No',
            },
          },
        ],
      },
    ],
  },
  {
    step: '17',
    stepName: 'dob',
    Container: ApplyBContainerExtraSmall,
    title: defaultMonthTitle,
    TitleContainer: TitleContainerB,
    form: [
      {
        Container: MonthsContainer,
        name: 'month',
        component: SelectMonths,
        props: {
          options: months.map((month) => ({
            placeholder: month.name,
            value: month.value,
          })),
        },
      },
    ],
  },
  {
    step: '18',
    Container: ApplyBContainerExtraSmall,
    title: defaultDayTitle,
    TitleContainer: TitleContainer,
    form: [
      {
        Container: MonthsContainer,
        name: 'day',
        component: SelectDay,
        props: {
          design: 'b',

          options: Array.from({ length: 31 }, (_, i) => ({
            placeholder: `${i + 1}`,
            value: `${i + 1}`,
          })),
        },
      },
    ],
  },
  {
    step: '19',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'What is your birth year?',
    allowSkip: true,
    continue: true,
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'year',
        component: MedicareYear,
        componentType: 'input',
        props: {
          design: 'b',
          height: '42px',
          width: '52px',
          padding: '0.8rem',
          id: 'year',
          name: 'year',
          label: '',
          // autoComplete: 'bday-year',
        },
      },
    ],
  },
  // {
  //   step: '19',
  //   Container: ContainerExtraSmall,
  //   TitleContainer: TitleContainer,
  //   title: 'What is your birth year?',
  //   continue: true,
  //   form: [
  //     {
  //       Container: SingleLineInputContainer,
  //       name: 'year',
  //       component: SingleLineInput,
  //       componentType: 'input',
  //       props: {
  //         id: 'year',
  //         name: 'year',
  //         label: '',
  //         autoComplete: 'bday-year',
  //       },
  //     },
  //   ],
  // },
  {
    step: '20',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'Please enter your street address',
    continue: true,
    stepRole: 'zip_code',
    form: [
      {
        Container: SingleLineInputContainerB,
        name: 'address_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Street Address',
          id: 'address_1',
          name: 'address_1',
          autoComplete: 'address-line1',
        },
      },
      {
        Container: SingleLineInputContainerB,
        name: 'zip_code',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Zip Code',
          id: 'zip_code',
          name: 'zip_code',
          autoComplete: 'postal-code',
        },
      },
      {
        Container: SingleLineInputContainerB,
        component: Select,
        componentType: 'select',
        name: 'state',
        // defaultValue: '5000',
        props: {
          design: 'b',
          height: '40px',
          mobileFriendlySelect: true,
          ariaLabel: 'state',
          label: 'State',
          size: 'small',
          labelProps: {
            labelSpace: '12px',
          },
          options: [
            { value: 'AZ', label: 'Arizona' },
            { value: 'AL', label: 'Alabama' },
            { value: 'AK', label: 'Alaska' },
            { value: 'AR', label: 'Arkansas' },
            { value: 'CA', label: 'California' },
            { value: 'CO', label: 'Colorado' },
            { value: 'CT', label: 'Connecticut' },
            { value: 'DC', label: 'District of Columbia' },
            { value: 'DE', label: 'Delaware' },
            { value: 'FL', label: 'Florida' },
            { value: 'GA', label: 'Georgia' },
            { value: 'HI', label: 'Hawaii' },
            { value: 'ID', label: 'Idaho' },
            { value: 'IL', label: 'Illinois' },
            { value: 'IN', label: 'Indiana' },
            { value: 'IA', label: 'Iowa' },
            { value: 'KS', label: 'Kansas' },
            { value: 'KY', label: 'Kentucky' },
            { value: 'LA', label: 'Louisiana' },
            { value: 'ME', label: 'Maine' },
            { value: 'MD', label: 'Maryland' },
            { value: 'MA', label: 'Massachusetts' },
            { value: 'MI', label: 'Michigan' },
            { value: 'MN', label: 'Minnesota' },
            { value: 'MS', label: 'Mississippi' },
            { value: 'MO', label: 'Missouri' },
            { value: 'MT', label: 'Montana' },
            { value: 'NE', label: 'Nebraska' },
            { value: 'NV', label: 'Nevada' },
            { value: 'NH', label: 'New Hampshire' },
            { value: 'NJ', label: 'New Jersey' },
            { value: 'NM', label: 'New Mexico' },
            { value: 'NY', label: 'New York' },
            { value: 'NC', label: 'North Carolina' },
            { value: 'ND', label: 'North Dakota' },
            { value: 'OH', label: 'Ohio' },
            { value: 'OK', label: 'Oklahoma' },
            { value: 'OR', label: 'Oregon' },
            { value: 'PA', label: 'Pennsylvania' },
            { value: 'RI', label: 'Rhode Island' },
            { value: 'SC', label: 'South Carolina' },
            { value: 'SD', label: 'South Dakota' },
            { value: 'TN', label: 'Tennessee' },
            { value: 'TX', label: 'Texas' },
            { value: 'UT', label: 'Utah' },
            { value: 'VT', label: 'Vermont' },
            { value: 'VA', label: 'Virginia' },
            { value: 'WA', label: 'Washington' },
            { value: 'WV', label: 'West Virginia' },
            { value: 'WI', label: 'Wisconsin' },
            { value: 'WY', label: 'Wyoming' },
          ].map(({ value, label }) => ({
            id: value,
            value: label,
            name: 'state',
          })),
        },
      },
    ],
  },
  {
    step: '21',
    Container: ApplyBContainerExtraSmall,
    TitleContainer: TitleContainerB,
    title: 'How may we contact you?',
    continue: true,
    form: [
      {
        Container: MultipleInputContainerBB,
        componentType: 'multi-input',
        children: [
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'first_name',
              name: 'first_name',
              label: 'First Name',
              autoComplete: 'given-name',
            },
          },
          {
            component: SingleLineInput,
            props: {
              design: 'b',
              height: '40px',
              labelProps: {
                labelSpace: '12px',
              },
              id: 'last_name',
              name: 'last_name',
              label: 'Last Name',
              autoComplete: 'family-name',
            },
          },
        ],
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'phone_1',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Phone Number',
          id: 'phone_1',
          name: 'phone_1',
          autoComplete: 'tel',
        },
      },
      {
        Container: SingleLineInputContainerBB,
        name: 'email',
        component: SingleLineInput,
        componentType: 'input',
        props: {
          design: 'b',
          height: '40px',
          labelProps: {
            labelSpace: '12px',
          },
          label: 'Email',
          id: 'email',
          name: 'email',
          autoComplete: 'email',
        },
      },
      {
        Container: OptinContainerB,
        name: 'optin',
        component: CheckElement,
        componentType: 'optin',
        props: {
          label: 'Yes, I would also like free quotes for Life Insurance',
          name: 'optin',
        },
      },
    ],
  },
]

const verticalsSteps = [
  {
    vertical: 'medicare',
    flow: 'a',
    steps: medicareD4Steps,
    showPrev: true,
    autoAdvance: true,
  },
  {
    vertical: 'medicare',
    flow: 'b',
    steps: medicareD4BSteps,
    showPrev: true,
    autoAdvance: true,
    design: 'b',
    thankYouPage: 'thank-you-b',
  },
  {
    vertical: 'life-insurance',
    flow: 'a',
    steps: lifeASteps,
    showPrev: true,
    autoAdvance: true,
  },
  {
    vertical: 'life-insurance',
    flow: 'b',
    steps: lifeBSteps,
    showPrev: true,
    autoAdvance: true,
    design: 'b',
    thankYouPage: 'thank-you-b',
  },
  {
    vertical: 'health-insurance',
    flow: 'a',
    steps: healthASteps,
    showPrev: true,
    autoAdvance: true,
  },
  {
    vertical: 'health-insurance',
    flow: 'b',
    steps: healthASteps,
    showPrev: true,
    autoAdvance: true,
    design: 'b',
    thankYouPage: 'thank-you-b',
  },
  {
    vertical: 'auto-insurance',
    flow: 'a',
    steps: autoASteps,
    showPrev: true,
    autoAdvance: true,
    thankYouPage: 'thank-you-auto',
    homeCX: false,
  },
  {
    vertical: 'auto-insurance',
    flow: 'b',
    steps: autoBSteps,
    showPrev: true,
    autoAdvance: true,
    thankYouPage: 'thank-you-auto',
    design: 'b',
    homeCX: false,
  },
  {
    vertical: 'auto-insurance',
    flow: 'bt',
    steps: autoBSteps,
    showPrev: true,
    autoAdvance: true,
    thankYouPage: 'thank-you-auto-t',
    design: 'b',
    homeCX: false,
  },
]

export default verticalsSteps
